/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_LoadingInputs */

const en_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading blog…`)
};

const es_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando blog…`)
};

const de_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog wird geladen…`)
};

const zh_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载博客…`)
};

const ar_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل المدونة…`)
};

const fr_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du blog…`)
};

const vi_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải blog…`)
};

const sw_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia blogu…`)
};

const th_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดบล็อก…`)
};

const bs_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitavanje bloga…`)
};

const ja_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブログの読み込み`)
};

const ko_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 …`)
};

const pt_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o blog…`)
};

const it_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento blog…`)
};

const sv_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar bloggen…`)
};

const nl_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog wordt geladen…`)
};

const da_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser blog…`)
};

const nb_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster blogg…`)
};

const fi_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan blogia`)
};

const pl_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie bloga…`)
};

const ru_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка блога…`)
};

const tr_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog yükleniyor…`)
};

const hi_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्लॉग`)
};

const id_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat blog…`)
};

const ms_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuatkan blog…`)
};

const cs_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávám blog…`)
};

const el_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φόρτωση blog…`)
};

const he_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען את הבלוג…`)
};

const af_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laai tans blog…`)
};

const hu_blog_loading = /** @type {(inputs: Blog_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog betöltése…`)
};

/**
* | output |
* | --- |
* | "Loading blog…" |
*
* @param {Blog_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_loading = /** @type {((inputs?: Blog_LoadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_LoadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_loading(inputs)
	if (locale === "de") return de_blog_loading(inputs)
	if (locale === "zh") return zh_blog_loading(inputs)
	if (locale === "ar") return ar_blog_loading(inputs)
	if (locale === "fr") return fr_blog_loading(inputs)
	if (locale === "vi") return vi_blog_loading(inputs)
	if (locale === "sw") return sw_blog_loading(inputs)
	if (locale === "th") return th_blog_loading(inputs)
	if (locale === "bs") return bs_blog_loading(inputs)
	if (locale === "ja") return ja_blog_loading(inputs)
	if (locale === "ko") return ko_blog_loading(inputs)
	if (locale === "pt") return pt_blog_loading(inputs)
	if (locale === "it") return it_blog_loading(inputs)
	if (locale === "sv") return sv_blog_loading(inputs)
	if (locale === "nl") return nl_blog_loading(inputs)
	if (locale === "da") return da_blog_loading(inputs)
	if (locale === "nb") return nb_blog_loading(inputs)
	if (locale === "fi") return fi_blog_loading(inputs)
	if (locale === "pl") return pl_blog_loading(inputs)
	if (locale === "ru") return ru_blog_loading(inputs)
	if (locale === "tr") return tr_blog_loading(inputs)
	if (locale === "hi") return hi_blog_loading(inputs)
	if (locale === "id") return id_blog_loading(inputs)
	if (locale === "ms") return ms_blog_loading(inputs)
	if (locale === "cs") return cs_blog_loading(inputs)
	if (locale === "el") return el_blog_loading(inputs)
	if (locale === "he") return he_blog_loading(inputs)
	if (locale === "af") return af_blog_loading(inputs)
	if (locale === "hu") return hu_blog_loading(inputs)
	return en_blog_loading(inputs)
});